import * as React from "react";
import { cn } from "@/lib/utils";
import { useHoloTiming } from "./holoTiming";

export interface HoloDotProps {
  /** What the dot means, for screen readers; leave it out when text beside the dot already says it. */
  label?: string;
  className?: string;
}

/**
 * A notification dot that drifts through the holo colors. The gradient is scaled far past the dot, so
 * as it turns the dot shifts color as a whole instead of showing a spinning wheel.
 */
export const HoloDot = React.forwardRef<HTMLSpanElement, HoloDotProps & React.HTMLAttributes<HTMLSpanElement>>(
  ({ label, className, style, ...props }, ref) => {
    const timing = useHoloTiming();
    return (
      <span
        ref={ref}
        {...(label ? { role: "img", "aria-label": label } : { "aria-hidden": true })}
        data-slot="holo-dot"
        style={{ ...timing, ...style }}
        className={cn(
          "inline-block size-2 shrink-0 rounded-full bg-holo-conic bg-[length:2000%_2000%] bg-left-top",
          "animate-holo-rotate motion-reduce:animate-none",
          className
        )}
        {...props}
      />
    );
  }
);
HoloDot.displayName = "HoloDot";
